import React, { useState } from "react";
import { auth } from "../Utils/firebase";
import {
    RecaptchaVerifier,
    signInWithPhoneNumber,
} from "firebase/auth";


const FirebaseOTP = () => {
    const [phone, setPhone] = useState("");
    const [otp, setOtp] = useState("");
    const [confirmation, setConfirmation] = useState(null);

    const generateRecaptcha = () => {
        if (!window.recaptchaVerifier) {
            window.recaptchaVerifier = new RecaptchaVerifier(
                auth,
                "recaptcha-container",
                {
                    size: "invisible",
                }
            );
        }
    };

    const sendOtp = async () => {
        try {
            generateRecaptcha();
            const appVerifier = window.recaptchaVerifier;

            const confirmationResult = await signInWithPhoneNumber(
                auth,
                phone,
                appVerifier
            );

            setConfirmation(confirmationResult);
            alert("OTP sent");
        } catch (err) {
            console.error(err);
            alert(err.message);
        }
    };

    const verifyOtp = async () => {
        try {
            await confirmation.confirm(otp);
            alert("OTP verified ✅");
        } catch (err) {
            alert("Invalid OTP ❌");
        }
    };

    return (
        <div>
            <input
                placeholder="+91XXXXXXXXXX"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
            />
            <button onClick={sendOtp}>Send OTP</button>

            <input
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
            />
            <button onClick={verifyOtp}>Verify OTP</button>

            <div id="recaptcha-container"></div>
        </div>
    );
};

export default FirebaseOTP;
